"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:title": "Referanser",
  "ui:options": {
    "draggable": true
  },
  "ui:sidebar": {
    "query": {
      "models": "documents",
      "documentType": "ekultur"
    }
  },
  "ui:buttons": [{
    "type": "sidebar",
    "icon": "search",
    "label": "Finn referanse"
  }],
  "items": {
    "ui:layout": "module",
    "ui:preview": {
      "select": {
        "imageUrl": "imageUrl",
        "title": "title"
      },

      prepare({
        formData
      }) {
        const imageUrl = formData.imageUrl,
              title = formData.title;
        return {
          imageUrl: imageUrl,
          title: title
        };
      }

    }
  }
};
exports.default = _default;
module.exports = exports.default;